module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1006.4e5a669c.png";